var _mask, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlagBusinessEnglish = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  y: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  y: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.57536 2.45406L2.45404 4.57538L9.87866 12L2.45404 19.4246L4.57536 21.5459L12 14.1213L19.4246 21.5459L21.5459 19.4246L14.1213 12L21.5459 4.57538L19.4246 2.45406L12 9.87868L4.57536 2.45406Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H10V10H0V14H10V24H14V14H24V10H14V0Z",
  fill: "#E6273E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.16116 20.1317L3.86827 20.8388L8.46446 16.2426C8.65972 16.0474 8.65972 15.7308 8.46446 15.5355C8.2692 15.3403 7.95262 15.3403 7.75735 15.5355L3.16116 20.1317ZM15.5355 8.46445C15.7308 8.65972 16.0474 8.65972 16.2426 8.46445L20.8388 3.86826L20.1317 3.16115L15.5355 7.75735C15.3403 7.95261 15.3403 8.26919 15.5355 8.46445ZM8.46447 7.75735C8.65973 7.95261 8.65973 8.26919 8.46447 8.46445C8.2692 8.65972 7.95262 8.65971 7.75736 8.46445L3.16117 3.86826L3.86827 3.16115L8.46447 7.75735ZM20.1317 20.8388L20.8388 20.1317L16.2426 15.5355C16.0474 15.3403 15.7308 15.3403 15.5355 15.5355C15.3403 15.7308 15.3403 16.0474 15.5355 16.2426L20.1317 20.8388Z",
  fill: "#E6273E"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.625 14.75H9.25V13.375C9.24958 13.0105 9.10458 12.661 8.84681 12.4032C8.58904 12.1454 8.23954 12.0004 7.875 12H5.125C4.76046 12.0004 4.41096 12.1454 4.15319 12.4032C3.89542 12.661 3.75042 13.0105 3.75 13.375V14.75H2.375C2.01046 14.7504 1.66096 14.8954 1.40319 15.1532C1.14542 15.411 1.00042 15.7605 1 16.125L1 21.625C1.00042 21.9895 1.14542 22.339 1.40319 22.5968C1.66096 22.8546 2.01046 22.9996 2.375 23H10.625C10.9895 22.9996 11.339 22.8546 11.5968 22.5968C11.8546 22.339 11.9996 21.9895 12 21.625V16.125C11.9996 15.7605 11.8546 15.411 11.5968 15.1532C11.339 14.8954 10.9895 14.7504 10.625 14.75ZM4.92857 13.375C4.92857 13.3229 4.94927 13.2729 4.9861 13.2361C5.02294 13.1993 5.0729 13.1786 5.125 13.1786H7.875C7.9271 13.1786 7.97706 13.1993 8.0139 13.2361C8.05073 13.2729 8.07143 13.3229 8.07143 13.375V14.75H4.92857V13.375Z",
  fill: "#153BFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6261 13.75C11.2555 13.7507 11.8589 14.0011 12.3039 14.4461C12.7489 14.8911 12.9993 15.4945 13 16.1239L13 16.125L13 21.6261C12.9993 22.2555 12.7489 22.8589 12.3039 23.3039C11.8589 23.7489 11.2555 23.9993 10.6261 24L10.625 24L2.37386 24C1.74449 23.9993 1.14111 23.7489 0.696081 23.3039C0.251052 22.8589 0.000719309 22.2555 1.2517e-06 21.6261L0 21.625L5.96046e-07 16.1239C0.000719309 15.4945 0.251052 14.8911 0.696081 14.4461C1.14111 14.0011 1.74449 13.7507 2.37386 13.75L2.375 13.75L2.75 13.75V13.3739C2.75072 12.7445 3.00105 12.1411 3.44608 11.6961C3.89111 11.2511 4.49449 11.0007 5.12386 11L5.125 11L7.87614 11C8.50551 11.0007 9.10889 11.2511 9.55392 11.6961C9.99895 12.1411 10.2493 12.7445 10.25 13.3739L10.25 13.375L10.25 13.75H10.6261ZM9.25 13.375V14.75H10.625C10.9895 14.7504 11.339 14.8954 11.5968 15.1532C11.8546 15.411 11.9996 15.7605 12 16.125V21.625C11.9996 21.9895 11.8546 22.339 11.5968 22.5968C11.339 22.8546 10.9895 22.9996 10.625 23H2.375C2.01046 22.9996 1.66096 22.8546 1.40319 22.5968C1.14542 22.339 1.00042 21.9895 1 21.625V16.125C1.00042 15.7605 1.14542 15.411 1.40319 15.1532C1.66096 14.8954 2.01046 14.7504 2.375 14.75H3.75V13.375C3.75042 13.0105 3.89542 12.661 4.15319 12.4032C4.41096 12.1454 4.76046 12.0004 5.125 12H7.875C8.23955 12.0004 8.58904 12.1454 8.84681 12.4032C9.10459 12.661 9.24959 13.0105 9.25 13.375ZM4.9861 13.2361C4.94927 13.2729 4.92857 13.3229 4.92857 13.375V14.75H8.07143V13.375C8.07143 13.3229 8.05073 13.2729 8.0139 13.2361C7.97706 13.1993 7.9271 13.1786 7.875 13.1786H5.125C5.0729 13.1786 5.02294 13.1993 4.9861 13.2361Z",
  fill: "white"
})));
export default SvgFlagBusinessEnglish;